import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

import { BookingTravellerDetailComponent } from "./booking-traveller-detail.component";
import { IdentityInfoModule } from "./components/identity-info/identity-info.module";
import { IdentityInfoEditorModule } from "libraries/component/identity-info-editor/identity-info-editor.module";
import { BtnModule } from "libraries/ui_button/btn.module";
import { NotificationModule } from "libraries/component/notification/notification.module";
import { PermissionModule } from "libraries/permission/permission.module";
import { GetIdentityInfoDisplayModePipe } from './pipes/get-identity-info-display-mode.pipe';
import { StringToDatePipe } from './pipes/string-to-date.pipe';
import { TitleToGenderModule } from "libraries/pipes/title-to-gender/title-to-gender.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        IdentityInfoModule,
        IdentityInfoEditorModule,
        BtnModule,
        NotificationModule,
        PermissionModule,
        TitleToGenderModule,
        FontAwesomeModule,
    ],
    exports: [
        BookingTravellerDetailComponent,
    ],
    declarations: [
        BookingTravellerDetailComponent,
        GetIdentityInfoDisplayModePipe,
        StringToDatePipe
    ],
    providers: [],
})
export class BookingTravellerDetailModule {
}
